import { useQuery } from "@tanstack/react-query";
import type { ConnectorRegistryRow } from "../components/connectors";
import {
  connectorCatalogSchemaApi,
  type BackendConnectorCatalogSchema,
} from "../services/api";
import { connectorRegistryService } from "../services/connectors/connectorRegistry.service";
import { queryKeys } from "../services/queryKeys";

export async function fetchConnectorRegistryRows(): Promise<
  ConnectorRegistryRow[]
> {
  return connectorRegistryService.list();
}

export const useConnectorRegistryQuery = () =>
  useQuery<ConnectorRegistryRow[]>({
    queryKey: queryKeys.connectors.registry(),
    queryFn: fetchConnectorRegistryRows,
  });

export const useConnectorCatalogSchemaQuery = (
  catalogKey: string | null,
  enabled = true,
) =>
  useQuery<BackendConnectorCatalogSchema>({
    queryKey: queryKeys.connectors.catalogSchema(catalogKey ?? "missing"),
    enabled: Boolean(catalogKey) && enabled,
    queryFn: async () => {
      if (!catalogKey) {
        throw new Error("Catalog key is required");
      }
      return connectorCatalogSchemaApi.get(catalogKey);
    },
  });
